import { ValidationRule } from "validation/validationRule"

// Here we can add all the rules that we can use in the validations object

export const isEmptyRule: ValidationRule = {
    validate: (value: any) => Boolean(value?.trim().length),
    errorMessage: "isEmpty_valid_err",
}

export const isMinLengthRule: ValidationRule = {
    validate: (value) => value?.length > 2,
    errorMessage: "length_valid_err",
}

export const isNoSymbolsRule: ValidationRule = {
    validate: (value) =>
        /^[A-Za-z\u0600-\u06FF]+(-[A-Za-z\u0600-\u06FF]+)*$/.test(value),
    errorMessage: "nameErr_valid_err",
}

export const isEmailRule: ValidationRule = {
    validate: (value) =>
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
    errorMessage: "email_valid_err",
}

export const isPhoneRule: ValidationRule = {
    validate: (value) => /^\d{9,}$/.test(value),
    errorMessage: "phone_valid_err",
}
